<template>
<div class="hello">
  <img class="mainpic" src="@/assets/logo.png">
  <h1 class="head slideInUp">{{ msg }}</h1>
</div>
</template>

<script>
export default {
  name: 'hello',

  data() {
    return {
      msg: 'Jancarus'
    }
  }
}
</script>

<style scoped>
img {
  width: 50vw;
  height: 30vw;
  display: block;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.hello {
  width: 100%;
  margin-top: 10px;
  height: 100%;
  position: relative;
}
.head {
  position: absolute;
  z-index: 1;
  font-weight: 700;
  font-family: 'Mada', sans-serif;
  text-transform: uppercase;
  letter-spacing: 15px;
  color: rgba(242, 242, 242, .8);
  font-size: 11vw;
  margin-top: auto;
  margin-bottom: auto;
  top: 30%;
  width: 100%;
  text-align: center;
}

h1,
h2 {
  font-weight: normal;
  text-shadow: 3px 3px 8px #4c4c4c;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.hello .slideInUp {
  -webkit-animation: slideInUp 1s 0.8s both;
  animation: slideInUp 1s 0.8s both;
  margin: auto;
}
@media screen and (max-width: 860px) {
  img {
    width: 70vw;
    height: 70vh;
    margin-left: auto;
    margin-right: auto;

  }}
  @media screen and (max-width: 500px) {
    img{
      width:80vw;
      height:auto;
      margin-top:60px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue